module.exports = __webpack_public_path__ + "img/i_list_like.b574b986.svg";